/* file description */

import * as React from 'react';
import { Modal } from 'antd';
import { Popup, Button } from 'antd-mobile';
import styles from './index.module.less';
import { CloseOutline } from 'antd-mobile-icons';
import useMetaStore from '@/store/useMetaStore';


export const QiankunModalLayout = (props: any) => {
  const { isMobile } = useMetaStore();

  if (isMobile) {
    return (
      <Popup
        {...props}
        destroyOnClose
        position="right"
        bodyStyle={{ width: '100vw' }}
      >
        <div
          className={styles['popup-box']}
        >
          <div className={styles['popup-spForm-box']}>
            {props.children}
          </div>
          <div
            className={styles['popup-close-icon']}
            onClick={props.onCancel}
          ><CloseOutline fontSize={24} />
          </div>
        </div>
      </Popup>
    );
  }

  return (
    <Modal maskClosable={false} {...props} > {props.children} </Modal>
  );
};
